<!--
 * @Author: your name
 * @Date: 2020-12-22 13:40:52
 * @LastEditTime: 2020-12-22 13:59:16
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/cart/component/AwaitTime/index.vue
-->
<style scoped lang="sass">
$textColor: var(--menu-primary-text-colour)
$bgc: var(--menu-primary-background-colour)

.await_container
  display: flex
  justify-content: center
  align-items: center
  margin-top: 25px
  line-height: 1
  font-size: 15px
  color: $textColor

.icon
  margin-right: 5px
  font-weight: 600
  color: $bgc !important

</style>

<template lang="pug">
.await_container
  icon.icon(size="20") timer
  span.text.b(v-if="full") {{ t('estimated_wait_time', 'Estimated wait time:') }} {{ awaitTime }} {{ t('mins', 'mins') }}
  span.text(v-else) {{ t('est_wait', 'Est. Wait:') }}
    span.text.b  {{ awaitTime }} {{ t('mins', 'mins') }}

</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import { t } from '@/utils/language'

@Component({
  props: {
    awaitTime: {
      type: [String, Number]
    },
    full: {
      type: Boolean,
      default: true
    }
  }
})

class AwaitTime extends Vue {
  t(key, fallback) {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return t(key, fallback)
  }
}

export default AwaitTime
</script>
